export default __webpack_public_path__ + "static/media/blue4.5ddc289a.gif";